exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../node_modules/css-loader/index.js?minimize!../Contratos/style.scss"), "");

// module
exports.push([module.id, ".covered-img{opacity:.4}.container{position:relative;text-align:center;color:#000}.centered{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2ed2b420","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/Documentos_extra/Carta_factura.vue
// module id = 921
// module chunks = 0